module.exports = __webpack_public_path__ + "static/media/conco.co.ed13789b.png";